module.exports = __webpack_public_path__ + "img/harsh-acceleration_map.33e508f3.svg";